import React, { PropsWithChildren } from 'react';
import LazyLoad from 'react-lazy-load';

interface Props {
  enabled?: boolean;
  width?: string | number;
  height?: string | number;
  offset?: string | number;
  children: React.ReactNode;
}

export const LazyLoadWrapper: React.FC<PropsWithChildren<Props>> = ({
  enabled,
  children,
  ...lazyLoadProps
}) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <LazyLoad throttle={100} {...lazyLoadProps}>
      {children}
    </LazyLoad>
  );
};
